import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Header, Paragraph } from 'components/patterns/Typography'
import { DrawerDivider } from 'components/patterns'
import { ReadOnlyParameterValue } from 'components/feature/NavigatorPanes/editors/base'
import OutputtingDataTo from 'components/feature/NavigatorPanes/OutputtingDataTo'
import TimerModeDescription from 'components/feature/TimerBoxEditor/TimerModeDescription'

import strings from 'utils/strings'
import { timerValue } from 'utils/timers'

import ConditionSimulator from 'components/feature/Simulation/ConditionSimulator'
import LogicSetEvaluationBanner from 'components/feature/Simulation/LogicSetEvaluationBanner'
import TimerSimulatedValueDisplay from 'components/feature/Simulation/TimerSimulatedValueDisplay'

import { TimerValueRow } from './TimerBoxSimulator.styles'
import { StyledConditionSimulator } from '../Simulation/ConditionSimulator/ConditionSimulator'

const TimerBoxSimulator = ({
  description,
  initialValue,
  timerMode,
  outputting,
  conditions,
  uri,
  current,
}) => (
  <>
    <Header type="h3" className="form-title">
      {description}
    </Header>
    <LogicSetEvaluationBanner evaluation={outputting} />
    <DrawerDivider />
    <TimerValueRow>
      <ReadOnlyParameterValue
        label={strings.timer_initial_value_label}
        value={timerValue(initialValue)}
        size="small"
      />
      <TimerSimulatedValueDisplay value={current} showHintText />
    </TimerValueRow>
    <DrawerDivider />
    <Paragraph weight="bold" size="small">
      {strings.timer_mode_label} {strings.timer_mode_numbers[timerMode]}
    </Paragraph>
    <TimerModeDescription
      mode={timerMode}
      initialValue={initialValue}
      uri={uri}
    />
    <DrawerDivider />

    <div>
      {conditions.map((conditionUri, idx) => (
        <div key={`condition-{$conditionUri}`}>
          <Header type="h4" key={`paragraph-${conditionUri}`}>
            {idx === 0
              ? strings.activate_query_label
              : strings.reset_query_label}
          </Header>
          <StyledConditionsList>
            <ConditionSimulator
              key={`condition-simulator-${conditionUri}`}
              uri={conditionUri}
            />
          </StyledConditionsList>
        </div>
      ))}
    </div>
    <OutputtingDataTo uri={uri} />
  </>
)

TimerBoxSimulator.propTypes = {
  uri: PropTypes.string,
  description: PropTypes.string,
  initialValue: PropTypes.number,
  current: PropTypes.number,
  timerMode: PropTypes.string,
  outputting: PropTypes.bool,
  conditions: PropTypes.array,
}

export default TimerBoxSimulator

const StyledConditionsList = styled.div`
  margin-bottom: 16px;
  ${StyledConditionSimulator} {
    border-top: none;
  }
`
